// svgs.js
import React from 'react'

export const svgs = {
  arrow_plain: {
    large: (
      <svg
        fill={'none'}
        height={'16'}
        transform={'scale(-1, 1)'}
        viewBox={'0 0 310 15'}
        width={'310'}
        x={'-310'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M3.92203 6.97728C54.2852 6.3468 104.694 6.93179 155.103 6.86679C205.467 6.95778 256.105 6.1583 306.285 6.97728C311.192 7.08128 311.284 8.13426 306.285 8.23176C256.059 9.05075 205.467 8.25126 155.103 8.34226C104.694 8.28376 54.2852 8.86225 3.92203 8.23176C-1.2152 8.15376 -1.39868 7.05528 3.92203 6.97728Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M304.381 14.5182C301.766 12.8225 300.014 10.1685 297.796 8.02385C297.504 7.73566 297.498 7.25982 297.783 6.96493C300.027 4.84708 301.653 2.0054 304.381 0.463926C304.932 0.18244 305.556 0.825838 305.284 1.37541C303.757 4.12325 300.956 5.76526 298.852 8.02385V6.95152C299.648 8.05066 306.844 13.5396 305.052 14.5114C304.839 14.6388 304.574 14.6321 304.375 14.5114L304.381 14.5182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M299.111 14.5182C296.495 12.8225 294.743 10.1685 292.526 8.02385C292.234 7.73566 292.227 7.25982 292.513 6.96493C294.756 4.84708 296.383 2.0121 299.111 0.463926C299.662 0.18244 300.286 0.825838 300.013 1.37541C298.487 4.12325 295.679 5.76526 293.588 8.02385V6.95152C294.385 8.05066 301.58 13.5396 299.788 14.5114C299.575 14.6388 299.31 14.6321 299.111 14.5114V14.5182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M293.839 14.5182C291.224 12.8225 289.472 10.1685 287.255 8.02385C286.962 7.73566 286.956 7.25982 287.241 6.96493C289.485 4.84708 291.111 2.0121 293.839 0.463926C294.39 0.18244 295.014 0.825838 294.742 1.37541C293.215 4.12325 290.414 5.76526 288.317 8.02385V6.95152C289.113 8.05066 296.309 13.5396 294.516 14.5114C294.304 14.6388 294.038 14.6321 293.839 14.5114V14.5182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M288.57 14.5182C285.954 12.8225 284.202 10.1618 281.985 8.02385C281.693 7.73566 281.686 7.25982 281.972 6.96493C284.215 4.84708 285.842 2.0121 288.57 0.463926C289.121 0.18244 289.745 0.825838 289.472 1.37541C287.946 4.12325 285.145 5.76526 283.047 8.02385V6.95152C283.844 8.05066 291.039 13.5396 289.247 14.5114C289.034 14.6388 288.769 14.6321 288.57 14.5114V14.5182Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
    medium: (
      <svg
        fill={'none'}
        height={'16'}
        transform={'scale(-1, 1)'}
        viewBox={'0 0 260 16'}
        width={'260'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M3.40179 7.37276C45.4794 6.74227 87.5955 7.32726 129.711 7.26226C171.789 7.35326 214.096 6.55378 256.021 7.37276C260.121 7.47676 260.198 8.52974 256.021 8.62724C214.058 9.44622 171.789 8.64674 129.711 8.73774C87.5955 8.67924 45.4794 9.25773 3.40179 8.62724C-0.890283 8.54924 -1.04357 7.45076 3.40179 7.37276Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M254.256 15.0182C251.641 13.3225 249.889 10.6685 247.671 8.52385C247.379 8.23566 247.373 7.75982 247.658 7.46493C249.902 5.34708 251.528 2.5054 254.256 0.963926C254.807 0.68244 255.431 1.32584 255.159 1.87541C253.632 4.62325 250.831 6.26526 248.727 8.52385V7.45152C249.523 8.55066 256.719 14.0396 254.927 15.0114C254.714 15.1388 254.449 15.1321 254.25 15.0114L254.256 15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M248.985 15.0182C246.37 13.3225 244.618 10.6685 242.401 8.52385C242.109 8.23566 242.102 7.75982 242.387 7.46493C244.631 5.34708 246.257 2.5121 248.985 0.963926C249.536 0.68244 250.16 1.32584 249.888 1.87541C248.362 4.62325 245.554 6.26526 243.463 8.52385V7.45152C244.259 8.55066 251.455 14.0396 249.663 15.0114C249.45 15.1388 249.185 15.1321 248.985 15.0114V15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M243.715 15.0182C241.099 13.3225 239.347 10.6685 237.13 8.52385C236.838 8.23566 236.831 7.75982 237.117 7.46493C239.36 5.34708 240.987 2.5121 243.715 0.963926C244.266 0.68244 244.89 1.32584 244.617 1.87541C243.091 4.62325 240.29 6.26526 238.192 8.52385V7.45152C238.989 8.55066 246.184 14.0396 244.392 15.0114C244.179 15.1388 243.914 15.1321 243.715 15.0114V15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M238.445 15.0182C235.829 13.3225 234.077 10.6618 231.86 8.52385C231.568 8.23566 231.561 7.75982 231.847 7.46493C234.09 5.34708 235.717 2.5121 238.445 0.963926C238.996 0.68244 239.62 1.32584 239.347 1.87541C237.821 4.62325 235.02 6.26526 232.922 8.52385V7.45152C233.719 8.55066 240.914 14.0396 239.122 15.0114C238.909 15.1388 238.644 15.1321 238.445 15.0114V15.0182Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
    small: (
      <svg
        fill={'none'}
        height={'16'}
        transform={'scale(-1, 1)'}
        viewBox={'0 0 100 16'}
        width={'100'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M1.91512 7.37276C17.9988 6.74227 34.0973 7.32726 50.1956 7.26226C66.2794 7.35326 82.4509 6.55378 98.4761 7.37276C100.043 7.47676 100.073 8.52974 98.4761 8.62724C82.4363 9.44622 66.2794 8.64674 50.1956 8.73774C34.0973 8.67924 17.9988 9.25773 1.91512 8.62724C0.274517 8.54924 0.215924 7.45076 1.91512 7.37276Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M96.5255 15.0182C93.9102 13.3226 92.1578 10.6685 89.9408 8.52388C89.6487 8.2357 89.6421 7.75985 89.9275 7.46496C92.1711 5.34711 93.7974 2.50543 96.5255 0.963957C97.0764 0.68247 97.7004 1.32587 97.4282 1.87544C95.9015 4.62328 93.1004 6.26529 90.9962 8.52388V7.45155C91.7927 8.55069 98.9881 14.0397 97.1959 15.0115C96.9835 15.1388 96.718 15.1321 96.5189 15.0115L96.5255 15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M91.2548 15.0182C88.6395 13.3226 86.8871 10.6685 84.67 8.52388C84.378 8.2357 84.3713 7.75985 84.6568 7.46496C86.9004 5.34711 88.5266 2.51213 91.2548 0.963957C91.8057 0.68247 92.4297 1.32587 92.1575 1.87544C90.6308 4.62328 87.823 6.26529 85.7321 8.52388V7.45155C86.5286 8.55069 93.724 14.0397 91.9318 15.0115C91.7194 15.1388 91.4539 15.1321 91.2548 15.0115V15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M85.984 15.0182C83.3687 13.3226 81.6163 10.6685 79.3993 8.52388C79.1072 8.2357 79.1006 7.75985 79.386 7.46496C81.6296 5.34711 83.2559 2.51213 85.984 0.963957C86.535 0.68247 87.1589 1.32587 86.8867 1.87544C85.36 4.62328 82.5589 6.26529 80.4613 8.52388V7.45155C81.2579 8.55069 88.4533 14.0397 86.6611 15.0115C86.4487 15.1388 86.1831 15.1321 85.984 15.0115V15.0182Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M80.714 15.0182C78.0987 13.3226 76.3463 10.6618 74.1293 8.52388C73.8372 8.2357 73.8306 7.75985 74.116 7.46496C76.3596 5.34711 77.9858 2.51213 80.714 0.963957C81.2649 0.68247 81.8889 1.32587 81.6167 1.87544C80.09 4.62328 77.2889 6.26529 75.1913 8.52388V7.45155C75.9879 8.55069 83.1833 14.0397 81.391 15.0115C81.1786 15.1388 80.9131 15.1321 80.714 15.0115V15.0182Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
  },
  arrow_hasgrass: {
    large: (
      <svg
        fill={'none'}
        height={'20'}
        viewBox={'0 0 310 21'}
        width={'310'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M149.62 13.7589C144.365 14.4121 139.082 13.806 133.806 13.8734C132.047 13.9003 130.295 13.9205 128.536 13.9878C128.087 14.008 127.704 13.6646 127.664 13.2134C127.664 13.1932 126.764 1.79218 126.757 1.76524L128.57 1.84605L126.697 13.2605C126.59 14.0821 125.435 14.338 124.992 13.6511L120.528 7.34791L122.26 6.57347L123.703 12.8834C123.851 13.4895 123.368 14.0956 122.743 14.0889C119.602 14.0754 116.454 14.2505 113.312 13.7521C112.594 13.6444 112.587 12.5602 113.312 12.4524C116.454 11.9541 119.602 12.1225 122.743 12.1157L121.783 13.3212L120.374 7.00446C120.253 6.47919 120.582 5.96066 121.105 5.83944C121.502 5.7519 121.891 5.92025 122.106 6.23003L126.536 12.5535L124.831 12.944L126.771 1.53628C126.851 1.03794 127.328 0.694499 127.825 0.782043C128.248 0.85612 128.55 1.2063 128.583 1.61709L129.416 13.0316L128.543 12.2167C132.054 12.3514 135.571 12.3649 139.082 12.2504C142.599 12.1831 146.116 11.9743 149.62 12.4524C150.345 12.5467 150.359 13.6579 149.62 13.7521V13.7589Z'
          }
          fill={'#181716'}
        />
        <path
          d={
            'M117.353 13.8603C98.0472 14.4972 78.7076 13.9063 59.3681 13.9719C40.0454 13.88 20.6382 14.6876 1.38324 13.8603C-0.444121 13.7618 -0.477961 12.6916 1.38324 12.5931C20.6382 11.7658 40.0454 12.5734 59.3681 12.4815C78.7076 12.5406 98.0472 11.9562 117.353 12.5931C119.265 12.6653 119.333 13.7815 117.353 13.8603Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M307.857 13.8591C279.513 14.4896 251.119 13.9046 222.725 13.9696C194.356 13.8786 165.863 14.6781 137.593 13.8591C134.91 13.7616 134.861 12.7021 137.593 12.6046C165.863 11.7856 194.356 12.5851 222.725 12.4941C251.119 12.5526 279.513 11.9741 307.857 12.6046C310.664 12.6761 310.764 13.7811 307.857 13.8591Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M5.32817 6.04795C7.97292 7.75171 9.74504 10.4185 11.987 12.5667C12.2824 12.8562 12.2891 13.3344 12.0005 13.6307C9.73161 15.7587 8.08703 18.614 5.32817 20.1629C4.77103 20.4457 4.14005 19.7992 4.41526 19.247C5.95915 16.486 8.79185 14.8361 10.9197 12.5667V13.6441C10.1142 12.5397 2.83781 7.02441 4.6502 6.04795C4.865 5.92 5.13351 5.92674 5.33488 6.04795H5.32817Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M10.6578 6.04795C13.3025 7.75171 15.0746 10.4185 17.3166 12.5667C17.612 12.8562 17.6187 13.3344 17.33 13.6307C15.0612 15.7587 13.4166 18.6073 10.6578 20.1629C10.1006 20.4457 9.46964 19.7992 9.74485 19.247C11.2887 16.486 14.1214 14.8361 16.2426 12.5667V13.6441C15.4371 12.5397 8.16069 7.02441 9.97308 6.04795C10.1879 5.92 10.4564 5.92674 10.6578 6.04795Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M15.981 6.04795C18.6258 7.75171 20.3979 10.4252 22.6399 12.5667C22.9352 12.8562 22.9419 13.3344 22.6533 13.6307C20.3844 15.7587 18.7399 18.6073 15.981 20.1629C15.4239 20.4457 14.7929 19.7992 15.0681 19.247C16.612 16.486 19.4447 14.8361 21.5659 12.5667V13.6441C20.7603 12.5397 13.4839 7.02441 15.2963 6.04795C15.5111 5.92 15.7796 5.92674 15.981 6.04795Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M21.3106 6.04795C23.9553 7.75171 25.7275 10.4252 27.9695 12.5667C28.2648 12.8562 28.2715 13.3344 27.9829 13.6307C25.714 15.7587 24.0695 18.6073 21.3106 20.1629C20.7534 20.4457 20.1225 19.7992 20.3977 19.247C21.9416 16.486 24.7743 14.8361 26.8954 12.5667V13.6441C26.0899 12.5397 18.8135 7.02441 20.6259 6.04795C20.8407 5.92 21.1092 5.92674 21.3106 6.04795Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
    medium: (
      <svg
        fill={'none'}
        height={'20'}
        viewBox={'0 0 261 20'}
        width={'261'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M150.496 13.2589C145.24 13.9121 139.957 13.306 134.681 13.3734C132.922 13.4003 131.17 13.4205 129.411 13.4878C128.962 13.508 128.579 13.1646 128.539 12.7134C128.539 12.6932 127.639 1.29218 127.633 1.26524L129.445 1.34605L127.572 12.7605C127.465 13.5821 126.31 13.838 125.867 13.1511L121.403 6.84791L123.135 6.07347L124.578 12.3834C124.726 12.9895 124.243 13.5956 123.618 13.5889C120.477 13.5754 117.329 13.7505 114.187 13.2521C113.469 13.1444 113.462 12.0602 114.187 11.9524C117.329 11.4541 120.477 11.6225 123.618 11.6157L122.659 12.8212L121.249 6.50446C121.128 5.97919 121.457 5.46066 121.981 5.33944C122.377 5.2519 122.766 5.42025 122.981 5.73003L127.411 12.0535L125.706 12.444L127.646 1.03628C127.727 0.537944 128.203 0.194499 128.7 0.282043C129.123 0.35612 129.425 0.706299 129.458 1.11709L130.291 12.5316L129.418 11.7167C132.929 11.8514 136.446 11.8649 139.957 11.7504C143.474 11.6831 146.992 11.4743 150.496 11.9524C151.221 12.0467 151.234 13.1579 150.496 13.2521V13.2589Z'
          }
          fill={'#181716'}
        />
        <path
          d={
            'M118.228 13.3603C98.9222 13.9972 79.5826 13.4063 60.2431 13.4719C40.9204 13.38 21.5132 14.1876 2.25824 13.3603C0.430879 13.2618 0.397039 12.1916 2.25824 12.0931C21.5132 11.2658 40.9204 12.0734 60.2431 11.9815C79.5826 12.0406 98.9222 11.4562 118.228 12.0931C120.14 12.1653 120.208 13.2815 118.228 13.3603Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M258.602 13.6272C238.453 14.2577 218.269 13.6727 198.085 13.7377C177.919 13.6467 157.664 14.4462 137.569 13.6272C135.661 13.5297 135.626 12.4703 137.569 12.3728C157.664 11.5538 177.919 12.3533 198.085 12.2623C218.269 12.3208 238.453 11.7423 258.602 12.3728C260.597 12.4443 260.668 13.5492 258.602 13.6272Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M6.20329 5.54796C8.84804 7.25172 10.6202 9.91847 12.8622 12.0667C13.1575 12.3563 13.1642 12.8344 12.8756 13.1307C10.6067 15.2587 8.96216 18.114 6.20329 19.6629C5.64615 19.9457 5.01517 19.2992 5.29038 18.747C6.83427 15.986 9.66698 14.3361 11.7949 12.0667V13.1442C10.9894 12.0397 3.71293 6.52442 5.52532 5.54796C5.74013 5.42001 6.00863 5.42674 6.21 5.54796H6.20329Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M11.5328 5.54796C14.1775 7.25172 15.9496 9.91847 18.1916 12.0667C18.487 12.3563 18.4937 12.8344 18.205 13.1307C15.9362 15.2587 14.2916 18.1073 11.5328 19.6629C10.9756 19.9457 10.3446 19.2992 10.6199 18.747C12.1637 15.986 14.9964 14.3361 17.1176 12.0667V13.1442C16.3121 12.0397 9.03569 6.52442 10.8481 5.54796C11.0629 5.42001 11.3314 5.42674 11.5328 5.54796Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M16.8562 5.54796C19.501 7.25172 21.2731 9.9252 23.5151 12.0667C23.8105 12.3563 23.8172 12.8344 23.5285 13.1307C21.2597 15.2587 19.6151 18.1073 16.8562 19.6629C16.2991 19.9457 15.6681 19.2992 15.9433 18.747C17.4872 15.986 20.3199 14.3361 22.4411 12.0667V13.1442C21.6356 12.0397 14.3592 6.52442 16.1716 5.54796C16.3864 5.42001 16.6549 5.42674 16.8562 5.54796Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M22.1857 5.54796C24.8305 7.25172 26.6026 9.9252 28.8446 12.0667C29.1399 12.3563 29.1466 12.8344 28.858 13.1307C26.5892 15.2587 24.9446 18.1073 22.1857 19.6629C21.6286 19.9457 20.9976 19.2992 21.2728 18.747C22.8167 15.986 25.6494 14.3361 27.7706 12.0667V13.1442C26.9651 12.0397 19.6886 6.52442 21.501 5.54796C21.7158 5.42001 21.9843 5.42674 22.1857 5.54796Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
    small: (
      <svg
        fill={'none'}
        height={'20'}
        viewBox={'0 0 101 20'}
        width={'101'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M91.3275 13.5273C86.0716 14.1806 80.7888 13.5745 75.5127 13.6418C73.754 13.6688 72.002 13.689 70.2433 13.7563C69.7936 13.7765 69.411 13.4331 69.3707 12.9819C69.3707 12.9617 68.4712 1.56064 68.4645 1.5337L70.2769 1.61451L68.4041 13.029C68.2967 13.8506 67.1421 14.1065 66.6991 13.4196L62.2352 7.11637L63.9671 6.34193L65.4103 12.6519C65.558 13.258 65.0747 13.8641 64.4504 13.8573C61.3089 13.8439 58.1607 14.0189 55.0192 13.5206C54.301 13.4129 54.2943 12.3287 55.0192 12.2209C58.1607 11.7226 61.3089 11.8909 64.4504 11.8842L63.4905 13.0896L62.0808 6.77292C61.96 6.24765 62.2889 5.72912 62.8125 5.6079C63.2086 5.52036 63.5979 5.68871 63.8127 5.99849L68.243 12.3219L66.538 12.7125L68.4779 1.30474C68.5585 0.806407 69.0351 0.462962 69.5318 0.550506C69.9547 0.624583 70.2568 0.974762 70.2903 1.38555L71.1227 12.8L70.25 11.9852C73.7607 12.1199 77.2781 12.1334 80.7888 12.0189C84.3061 11.9515 87.8235 11.7428 91.3275 12.2209C92.0524 12.3152 92.0659 13.4263 91.3275 13.5206V13.5273Z'
          }
          fill={'#181716'}
        />
        <path
          d={
            'M56.6372 13.3588C47.3754 13.9893 38.0972 13.4043 28.8191 13.4693C19.5491 13.3783 10.2385 14.1778 1.00101 13.3588C0.124336 13.2613 0.108102 12.2018 1.00101 12.1043C10.2385 11.2853 19.5491 12.0848 28.8191 11.9938C38.0972 12.0523 47.3754 11.4738 56.6372 12.1043C57.5545 12.1758 57.587 13.2808 56.6372 13.3588Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M100.368 13.6272C96.4683 14.2577 92.5617 13.6727 88.6551 13.7377C84.752 13.6467 80.8317 14.4462 76.9423 13.6272C76.5731 13.5297 76.5663 12.4703 76.9423 12.3728C80.8317 11.5538 84.752 12.3533 88.6551 12.2623C92.5617 12.3208 96.4683 11.7423 100.368 12.3728C100.754 12.4443 100.768 13.5492 100.368 13.6272Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M5.66557 5.27955C8.31032 6.98331 10.0824 9.65006 12.3244 11.7983C12.6198 12.0878 12.6265 12.566 12.3379 12.8623C10.069 14.9903 8.42444 17.8456 5.66557 19.3945C5.10843 19.6773 4.47745 19.0308 4.75266 18.4786C6.29655 15.7176 9.12926 14.0677 11.2571 11.7983V12.8757C10.4516 11.7713 3.17521 6.25601 4.9876 5.27955C5.20241 5.1516 5.47091 5.15833 5.67228 5.27955H5.66557Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M10.9952 5.27955C13.6399 6.98331 15.412 9.65006 17.654 11.7983C17.9494 12.0878 17.9561 12.566 17.6674 12.8623C15.3986 14.9903 13.754 17.8389 10.9952 19.3945C10.438 19.6773 9.80704 19.0308 10.0823 18.4786C11.6261 15.7176 14.4588 14.0677 16.58 11.7983V12.8757C15.7745 11.7713 8.49809 6.25601 10.3105 5.27955C10.5253 5.1516 10.7938 5.15833 10.9952 5.27955Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M16.3186 5.27955C18.9634 6.98331 20.7355 9.65679 22.9775 11.7983C23.2729 12.0878 23.2796 12.566 22.9909 12.8623C20.7221 14.9903 19.0775 17.8389 16.3186 19.3945C15.7615 19.6773 15.1305 19.0308 15.4057 18.4786C16.9496 15.7176 19.7823 14.0677 21.9035 11.7983V12.8757C21.098 11.7713 13.8216 6.25601 15.634 5.27955C15.8488 5.1516 16.1173 5.15833 16.3186 5.27955Z'
          }
          fill={'#191916'}
        />
        <path
          d={
            'M21.648 5.27955C24.2927 6.98331 26.0649 9.65679 28.3069 11.7983C28.6022 12.0878 28.6089 12.566 28.3203 12.8623C26.0514 14.9903 24.4069 17.8389 21.648 19.3945C21.0909 19.6773 20.4599 19.0308 20.7351 18.4786C22.279 15.7176 25.1117 14.0677 27.2328 11.7983V12.8757C26.4273 11.7713 19.1509 6.25601 20.9633 5.27955C21.1781 5.1516 21.4466 5.15833 21.648 5.27955Z'
          }
          fill={'#191916'}
        />
      </svg>
    ),
  },
}
